import {combineReducers} from 'redux';
import persistedAuthReducer, {AuthState} from './modules/auth/reducer';
import persistedPlotsReducer, {StatisticsState} from './modules/plots/reducer';

// Define RootState interface
export interface RootState {
    auth: AuthState; // State shape managed by the auth reducer
    statistics: StatisticsState; // State shape managed by the statistics reducer
}

const rootReducer = combineReducers({
    auth: persistedAuthReducer, // Auth-related reducer with persistence enabled
    statistics: persistedPlotsReducer, // Statistics-related reducer with persistence enabled
});

export default rootReducer;

/**
 * Root Reducer and State Interface
 *
 * This module defines and exports the combined root reducer for the Redux store. It combines
 * multiple feature reducers and integrates them into a single reducer to manage the global
 * application state.
 */